// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"123":"9a5f0abe","585":"c5e6a2c2"}[chunkId] + ".chunk.js";
};